<!-- <ng-sidebar-container (onBackdropClicked)="_onBackdropClicked()">
<ng-sidebar *ngIf="isNotLoginPage$ | async" [opened]="menuState$ | async" [mode]="'over'" [closeOnClickOutside]="true"
  [closeOnClickBackdrop]="true" (onClosed)="_onClosed()" (onOpened)="_onOpened()" [showBackdrop]="true"
  class="kn-br-sidebar">
  <cx-page-slot position="TopHeaderSlot"></cx-page-slot>
</ng-sidebar>
<div ng-sidebar-content>
  <kn-br-outlet></kn-br-outlet>
  <cx-storefront [ngClass]="{ 'asm-storefront': isLoggedInASM }"></cx-storefront>
</div>
</ng-sidebar-container> -->
<mat-sidenav-container (backdropClick)="_onBackdropClicked()" class="drawer-container">
  <!-- Drawer -->
  <mat-sidenav
    mode="over"
    [opened]="menuState$ | async"
    (closedStart)="_onClosed()"
    (openedStart)="_onOpened()"
    class="kn-br-sidebar"
    >
    <cx-page-slot position="TopHeaderSlot"></cx-page-slot>
  </mat-sidenav>

  <!-- Main Content -->
  <mat-sidenav-content>
    <div class="main-content">
      <kn-br-outlet></kn-br-outlet>
      <cx-storefront [ngClass]="{ 'asm-storefront': isLoggedInASM }"></cx-storefront>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>



@if ({spinnerActive:commonService.showSpinner$ | async}; as $) {
  @if ($.spinnerActive) {
    <cx-spinner class="cx-dialog-popover-center-backdrop"></cx-spinner>
  }
}

<ng-template cxOutletRef="SalesLandingPage2Template">
  <knbr-kn-br-sales-landing></knbr-kn-br-sales-landing>
</ng-template>
